/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      $( '.choice-slider input' ).on( 'change', function() {
        $( this ).closest( '.section' ).find( '.choice-image' ).not( $( this ).attr( 'data-image' ) ).removeClass( 'is-active' );
        $( this ).closest( '.section' ).find( '.choice-image' + $( this ).attr( 'data-image' ) ).addClass( 'is-active' );

        $( this ).closest( '.section' ).find( '.choice-mobile-label' ).not( $( this ).attr( 'data-mobile-label' ) ).removeClass( 'is-active' );
        $( this ).closest( '.section' ).find( '.choice-mobile-label' + $( this ).attr( 'data-mobile-label' ) ).addClass( 'is-active' );
      } );

      $( '.coffee-finder-tool .prev-section' ).on( 'click', function( e ) {
        e.preventDefault();
        const thisPage = $( this ).closest( '.section' );
        const prevPage = $( this ).closest( '.section' ).prev();
        $( thisPage ).find( 'input' ).prop( 'checked', false );
        $( thisPage ).find( '.choice-image, .choice-mobile-label' ).removeClass( 'is-active' );
        $( thisPage ).removeClass( 'is-active' );
        $( prevPage ).addClass( 'is-active' );
      } );

      $( '.coffee-finder-tool .section input' ).on( 'change', function() {
        $( this ).closest( '.section' ).find( '.btn' ).removeAttr( 'disabled' );
      } );

      $( '.cft-form button[type="submit"]' ).on( 'click', function( e ) {
        e.preventDefault();
        $( 'html, body' ).animate( {
          scrollTop: 0,
        } );
        $( '.coffee-finder-tool' ).addClass( 'is-loading' );

        const button = this;
        const thisPage = $( button ).closest( '.section' );
        const nextPage = $( button ).closest( '.section' ).next();
        const thisPageFilter = $( button ).closest( '.section' ).attr( 'data-filter' );
        const nextPageFilter = $( button ).closest( '.section' ).next().attr( 'data-filter' );
        const data = {
          'barrel-aged': $( '.coffee-finder-tool input[name="barrel-aged"]:checked' ).val(),
          'caffeine': $( '.coffee-finder-tool input[name="caffeine"]:checked' ).val(),
          'grind-type': $( '.coffee-finder-tool input[name="grind-type"]:checked' ).val(),
          'roast': $( '.coffee-finder-tool input[name="roast"]:checked' ).val(),
          'flavor': $( '.coffee-finder-tool input[name="flavor"]:checked' ).val(),
          'coffee-amount': $( '.coffee-finder-tool input[name="coffee-amount"]:checked' ).val(),
          'gift': $( '.coffee-finder-tool input[name="gift"]:checked' ).val(),
          'this-page': thisPageFilter,
          'next-page': nextPageFilter,
        };

        $.ajax( {
          type: 'GET',
          url: site_info.wpApiSettings.ll + 'cpt/findCFTResult', // note that cpt/filter is the path set in our new route in routes.php
          data: data,
          beforeSend: function( xhr ) {
            xhr.setRequestHeader( 'X-WP-Nonce', site_info.wpApiSettings.nonce );
            xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
            doingAjax = true;
          },
          success: function( data ) {
            const terms = Object.values( data.terms );

            $( nextPage ).find( '[data-term]' ).each( function( key, choice ) {
              let showChoice = false;
              const choiceTerms = $( choice ).attr( 'data-term' ).split( ',' );
              $( choiceTerms ).each( function( termKey, term ) {
                if ( terms.includes( parseInt( term ) ) ) {
                  showChoice = true;
                }
              } );

              if ( showChoice ) {
                $( choice ).show().addClass( 'is-available' );
              } else {
                $( choice ).hide().removeClass( 'is-available' );
              }
            } );

            if ( nextPageFilter == 'grind-type' || nextPageFilter == 'coffee-amount' ) {
              const totalChoices = $( nextPage ).find( '.choice.is-available input' ).length;
              $( $( nextPage ).find( '.choice.is-available' )[Math.round( totalChoices / 2 ) - 1] ).find( 'input' ).prop( 'checked', true );

              $( $( $( nextPage ).find( '.choice.is-available' )[Math.round( totalChoices / 2 ) - 1] ).find( 'input' ).attr( 'data-image' ) ).addClass( 'is-active' );
              $( $( $( nextPage ).find( '.choice.is-available' )[Math.round( totalChoices / 2 ) - 1] ).find( 'input' ).attr( 'data-mobile-label' ) ).addClass( 'is-active' );
            }

            $( thisPage ).removeClass( 'is-active' );
            if ( !data.html && $( nextPage ).find( '.choice.is-available' ).length == 0 ) {
              $( nextPage ).find( 'button[type="submit"]' ).trigger( 'click' );
            } else {
              $( nextPage ).addClass( 'is-active' );
              $( '.coffee-match__wrapper' ).html( data.html );
            }
          },
          complete: function( jqXHR, status ) {
            doingAjax = false;
            $( '.coffee-finder-tool' ).removeClass( 'is-loading' );
          },
        } );
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'coffee-finder-tool', COMPONENT );
} )( app );
